import { STOCK_SOURCE_CENTRAL, STOCK_SOURCE_DISTRIBUTOR } from './constants/orders';

export function availabilityFor(article, stockSource) {
  if (!article) return 0;

  return Number(
    stockSource === STOCK_SOURCE_DISTRIBUTOR ? article.distributorAvailability : article.centralAvailability
  );
}

export function sameVarietyArticlesFor(item, articles) {
  if (!item) return [];

  return (articles || []).filter((article) => Number(article.varietyId) === Number(item.varietyId));
}

export function isArticleAvailableFor(item, article, stockSource) {
  if (!item || !article) return false;
  if (Number(article.varietyId) !== Number(item.varietyId)) return false;

  const currentArticleInCurrentSource =
    Number(article.id) === Number(item.articleId) && stockSource === item.stockSource;

  return availabilityFor(article, stockSource) >= Number(item.quantity) || currentArticleInCurrentSource;
}

export function eligibleArticlesFor(item, articles, stockSource) {
  return sameVarietyArticlesFor(item, articles).filter((article) => isArticleAvailableFor(item, article, stockSource));
}

export function sourceLabel(stockSource) {
  return stockSource === STOCK_SOURCE_DISTRIBUTOR ? 'MiDepósito' : 'Casa Central';
}

export function hasFinancialCorrectionBlocker(context) {
  return Boolean(
    context && (context.blockers || []).some((blocker) => ['receipt', 'liquidation'].includes(blocker.code))
  );
}

export function hasControlledCorrectionItems(context) {
  return Boolean(context && Array.isArray(context.items) && context.items.length > 0);
}

export function correctionModeForContext(context) {
  if (hasFinancialCorrectionBlocker(context)) return 'restricted';
  if (context && context.sameVarietyEligible && hasControlledCorrectionItems(context)) return 'source-first';

  return 'standard';
}

export function shouldShowGenericOrderForm(orderState, correctionMode) {
  return orderState !== 'accepted' || ['standard', 'source-first'].includes(correctionMode);
}

export function isValidFinancialValue(value) {
  if (value === '' || value === null || typeof value === 'undefined') return false;

  const numericValue = Number(value);
  return Number.isFinite(numericValue) && numericValue >= 0;
}

export function hasSameVarietyDraftChanges(item, draft, includeFinancialValues = false) {
  const sourceOrArticleChanged =
    Number(draft.articleId) !== Number(item.articleId) || draft.stockSource !== item.stockSource;

  if (!includeFinancialValues) return sourceOrArticleChanged;

  return (
    sourceOrArticleChanged ||
    Number(draft.unitPrice) !== Number(item.unitPrice) ||
    Number(draft.distributorCost) !== Number(item.distributorCost)
  );
}

export function buildSameVarietyPayload(orderUpdatedAt, item, draft, includeFinancialValues = false) {
  const payload = {
    order_updated_at: orderUpdatedAt,
    item_id: item.id,
    article_id: draft.articleId,
    stock_source: draft.stockSource,
    reason: draft.reason.trim(),
  };

  if (includeFinancialValues) {
    payload.unit_price = Number(draft.unitPrice);
    payload.distributor_cost = Number(draft.distributorCost);
  }

  return payload;
}

export function buildControlledCorrectionOrderPatch(order) {
  return {
    stockSource: order.stockSource || STOCK_SOURCE_CENTRAL,
    items: order.items || [],
  };
}

export function normalizeControlledCorrectionErrors(errors) {
  if (Array.isArray(errors)) return errors;

  const response = errors && errors.response && errors.response.data;
  if (response && response.errors) {
    const messages = Object.keys(response.errors).reduce((all, field) => {
      const fieldErrors = response.errors[field];
      return all.concat(Array.isArray(fieldErrors) ? fieldErrors : [fieldErrors]);
    }, []);

    if (messages.length) return messages;
  }

  if (response && response.message) return [response.message];

  return ['No pudimos guardar la corrección. Revisá los datos e intentá nuevamente.'];
}
